/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const informationSecurityCybersecurityEnumsDataPotentiallyCompromisedOptionEnum = {
    Yes: 'Yes',
    No: 'No',
    CannotSpecify: 'CannotSpecify',
} as const;

export type InformationSecurityCybersecurityEnumsDataPotentiallyCompromisedOptionEnumKey =
    (typeof informationSecurityCybersecurityEnumsDataPotentiallyCompromisedOptionEnum)[keyof typeof informationSecurityCybersecurityEnumsDataPotentiallyCompromisedOptionEnum];

export type InformationSecurityCybersecurityEnumsDataPotentiallyCompromisedOption =
    InformationSecurityCybersecurityEnumsDataPotentiallyCompromisedOptionEnumKey;
